import { gridDateComparator } from '../hooks/features/sorting/gridSortingUtils';
import { getGridDateOperators } from './gridDateOperators';
import { GRID_STRING_COL_DEF } from './gridStringColDef';
import type { GridColTypeDef, GridValueFormatter } from '../models/colDef/gridColDef';
import { renderEditDateCell } from '../components/cell/GridEditDateCell';
import { gridRowIdSelector } from '../hooks/core/gridPropsSelectors';
import { isAutogeneratedRow } from '../hooks/features/rows/gridRowsUtils';

function throwIfNotDateObject({
  value,
  columnType,
  rowId,
  field,
}: {
  value: any;
  columnType: string;
  rowId: any;
  field: string;
}) {
  if (!(value instanceof Date)) {
    throw new Error(
      `MUI X Data Grid: The "${columnType}" column type only accepts Date objects as values. ` +
        `Received value of type "${typeof value}" for row ID "${rowId}", field "${field}". ` +
        'Use valueGetter to transform the value into a Date object.',
    );
  }
}

export const gridDateFormatter: GridValueFormatter = (value: Date, row, column, apiRef): string => {
  if (!value) {
    return '';
  }
  const rowId = gridRowIdSelector(apiRef, row);
  if (isAutogeneratedRow(row) && !(value instanceof Date)) {
    return value;
  }
  throwIfNotDateObject({ value, columnType: 'date', rowId, field: column.field });
  return value.toLocaleDateString();
};

export const gridDateTimeFormatter: GridValueFormatter = (
  value: Date,
  row,
  column,
  apiRef,
): string => {
  if (!value) {
    return '';
  }
  const rowId = gridRowIdSelector(apiRef, row);
  if (isAutogeneratedRow(row) && !(value instanceof Date)) {
    return value;
  }
  throwIfNotDateObject({ value, columnType: 'dateTime', rowId, field: column.field });
  return value.toLocaleString();
};

export const GRID_DATE_COL_DEF: GridColTypeDef<Date, string> = {
  ...GRID_STRING_COL_DEF,
  type: 'date',
  sortComparator: gridDateComparator,
  valueFormatter: gridDateFormatter,
  filterOperators: getGridDateOperators(),
  renderEditCell: renderEditDateCell,
  // @ts-ignore
  pastedValueParser: (value) => new Date(value),
};

export const GRID_DATETIME_COL_DEF: GridColTypeDef<Date, string> = {
  ...GRID_STRING_COL_DEF,
  type: 'dateTime',
  sortComparator: gridDateComparator,
  valueFormatter: gridDateTimeFormatter,
  filterOperators: getGridDateOperators(true),
  renderEditCell: renderEditDateCell,
  // @ts-ignore
  pastedValueParser: (value) => new Date(value),
};
